// src/pages/wartungsprotokoll/WartungsprotokollSeite10.jsx

import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

export default function WartungsprotokollSeite10({ form, setForm }) {

   const [showZusatz1, setShowZusatz1] = useState(false);

  if (
    !form ||
    !form.pruefungMSP ||
    !form.zusatzMSP
  ) return null;

  const updateRow = (section, index, field) => {
    setForm(prev => {
      const updated = [...prev[section]];
      updated[index][field] = !updated[index][field];
      return { ...prev, [section]: updated };
    });
  };

  const updateZusatz = (table, index, field, value) => {
    setForm(prev => {
      const updated = [...prev[table]];
      updated[index][field] = value;
      return { ...prev, [table]: updated };
    });
  };

  const rows14 = [
    "14.1 Die Gebäude der MSP-Anlagen sind frei und zugänglich",
    "14.2 Die Gebäude der MSP-Anlagen befinden sich in gutem Zustand",
    "14.3 Innenraum der Gebäude in Ordnung (Verschmutzung, Feuchtigkeit, usw.)",
    "14.4 Türen in Ordnung (Dichtungen, Scharniere, Verriegelungen)",
    "14.5 Heizung vorhanden und betriebsbereit",
    "14.6 Hygrostat in Ordnung",
    "14.7 Reinigung Luftkanal, Insektenschutzgitter und Filter durchgeführt",
    "14.8 Lüfter in Ordnung",
    "14.9 Reinigung Lüfter durchgeführt",
    "14.10 Stationsbeleuchtung und Steckdosen in Ordnung",
    "14.11 Die Kabelverschraubungen sind fest und dicht",
    "14.12 Die Anzugsmomente aller Schrauben sind richtig (Kabelanschlüsse)",
    "14.13 Sammelschienen und Isolatoren sind in Ordnung (bei Bedarf gereinigt)",
    "14.14 Klemmenverbindung der Leistungskabelung in Ordnung",
    "14.15 Steck-/Klemmverbindung der Strangkabelung in Ordnung",
    "14.16 Erdverbindungen in Ordnung",
    "14.17 Sicherungen in Ordnung",
    "14.18 Isolierungen in Ordnung",
    "14.19 Berührungsschutz vorhanden und in Ordnung",
    "14.20 Erdungsscharnitur, Betätigungshebel für Schaltanlage, Spannungsprüfer i.O.",
    "14.21 Notfallplan vorhanden und aktuell",
    "14.22 Warnschilder und Beschriftungen vorhanden und i.O.",
    "14.23 NSHV in Ordnung",
    "14.24 Gasdruck der SF6-Schaltanlage in Ordnung",
    "14.25 Trafo, Öl, Kühlung, Flüssigkeitsstand in Ordnung",
    "14.26 Netz- und Anlagenschutz in Betrieb ohne Fehlermeldungen",
    "14.27 Versorgungsspannung in Ordnung",
    "14.28 USV funktionsfähig, Batterien in Ordnung (Schutzgerät, usw.)",
    "14.29 Parkregelung in Betrieb und ohne Fehlermeldungen"
  ];

  return (
      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
    <div className="p-6 text-sm">

      <h2 style={{ fontWeight: "bold" }}>
        14 Prüfung Mittelspannungsanlagen – erweitert
      </h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {rows14.map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
               
                <input
                  type="checkbox"
                  checked={form.pruefungMSP?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMSP || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungMSP: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungMSP?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMSP || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungMSP: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
             
                <input
                  type="checkbox"
                  checked={form.pruefungMSP?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMSP || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungMSP: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

             {/* Button for ZUSATZ-TABELLE #1 */}
                <Box mb={3} mt={4}>
            
                    <Button
                      onClick={() => setShowZusatz1(!showZusatz1)}
                      colorScheme="blue"
                      borderRadius="lg"
                    >
                      {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
                    </Button>
            
               </Box>

               
      {/* Zusatz-Tabelle */}

      {showZusatz1 && (
        <>
      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen/Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatzMSP.map((row, idx) => (
            <tr key={idx}>
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row[field]}
                    onChange={e => updateZusatz("zusatzMSP", idx, field, e.target.value)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#f7f7fb",
                      height: "18px"
                    }}
                  />
                </td>
              ))}

              <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={() => updateZusatz("zusatzMSP", idx, "plan", !row.plan)}
                />
              </td>

              <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz("zusatzMSP", idx, "bildnr", e.target.value)}
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    height: "18px"
                  }}
                />
              </td>

              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row[field]}
                    onChange={() => updateZusatz("zusatzMSP", idx, field, !row[field])}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
         </>
       )}

    </div>
    </Box>
  );
}